import { useCookies } from "react-cookie";
import { COMPARA_COOKIES_USER_ID } from "./constants";

const getComparaUserIdFromCookies = (): string | undefined => {
  const [cookies] = useCookies();
  const userId = cookies[COMPARA_COOKIES_USER_ID];
  return Boolean(userId) ? userId : undefined;
};

const toISOString = (timestamp: number) => new Date(timestamp * 1000).toISOString();

const FETCH_OPTIONS = {
  headers: { "Content-Type": "application/json" },
  method: "POST"
};

const sendRequest = (url: string, body: object) =>
  fetch(url, { ...FETCH_OPTIONS, body: JSON.stringify(body) }).then(response => response.json());

export { getComparaUserIdFromCookies, sendRequest, toISOString };
